"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var gridRow_1 = require("./gridRow");
var GridBody = /** @class */ (function (_super) {
    __extends(GridBody, _super);
    function GridBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridBody.prototype.render = function () {
        var _this = this;
        var rows = this.props.rows && this.props.rows.length > 0 ?
            this.props.rows.map(function (row, index) {
                var key = "jt-body-tr-" + index;
                return React.createElement(gridRow_1.GridRow, { row: row, columns: _this.props.columns, settings: _this.props.settings, onClickCell: _this.props.onClickCell, onClickRow: _this.props.onClickRow, index: index, key: key });
            }) :
            React.createElement("tr", null,
                React.createElement("td", null, this.props.settings.noRowsMessage));
        return React.createElement("tbody", null, rows);
    };
    return GridBody;
}(React.Component));
exports.GridBody = GridBody;
//# sourceMappingURL=gridBody.js.map